module.exports = __webpack_public_path__ + "img/profession.5492355a.png";